import NavBar from '../NavBar'
import ProgramHeader from '../../ReusableComponents/Header/ProgramHeader'
import styles from './TrainMachine.module.css'
import selectbarY from '../../../Assets/Bisoft_UI/AppMode/selectbar.png'
import nextY from '../../../Assets/Bisoft_UI/Buttons/Active without shadow/next.png'
import backY from '../../../Assets/Bisoft_UI/Buttons/Active without shadow/back.png'
import { useRef, useState, useEffect } from 'react'
import LeftTrainingClass from './LeftTrainingClass'
import CamModule from './CamModel'
import { useHistory } from 'react-router'
import { connect } from 'react-redux'
import AudioModule from './audioModel/AudioModel'
import { useIndexedDB } from 'react-indexed-db'
import * as tf from '@tensorflow/tfjs'
import renderPrgImage from '../../../source/programImg'
import DialogModal from '../../ReusableComponents/DialogModal/DialogModal'
import renderImage from '../../../source/importImg'
import {
    randomNumberGenerator,
    DEFAULT_EPOCHS,
    DEFAULT_BATCH_SIZE,
    createDefaultAudioClasses,
} from '../../../redux/reducers/appModeStorage'
import { checkSamplesPresent } from './TrainMachine/db/sampleValidator'
import useMobilenetLoader from './TrainMachine/hooks/useMobilenetLoader'
import useJsPlumbConnections from './TrainMachine/hooks/useJsPlumbConnection'
import { validateModelName } from './TrainMachine/utils/modelValidation'
import { buildSequentialModel } from './TrainMachine/Training/tfModelBuilder'
import {
    freshTransferRecognizer,
} from './audio/transferRecognizerRegistry'
import TrainingPanel from './TrainMachine/TrainingPanel'
import ModelNameDialog from './TrainMachine/ModelNameDialog'
import '@tensorflow/tfjs-backend-webgl'
import { trainSingleModel } from './CNNTrainingModule'
import { trainPoseModel } from './PoseTrainingModule'
import { trainKnnModel } from './KNNTrainingModule'
import { repairTfjsDb } from '../../WebAi/aiProjectStore'
import {
    getGestureRecognizerImage,
    handVectorFromResult,
    getPoseLandmarker,
    getPoseLandmarkerImage,
    poseVectorFromResult,
    nextVideoTimestamp,
} from '../../WebAi/vision/mediapipeRuntime'
import ROIModule from './ROIModule'

if (!window.numeric) {
    console.error('numeric.js not loaded — homography will fail.')
}

function TrainMachine(props) {
    const history = useHistory()

    const leftContainerRef = useRef(null) // Reference to the left scrollable div
    const connectionContainerRef = useRef(null) // Reference to the container holding the connections
    const jsPlumbInstance = useRef(null) // Reference to jsPlumb instance

    // Refs for training data to avoid global pollution and race conditions
    const classNamesRef = useRef([])
    const trainingDataInputsRef = useRef([])
    const trainingDataOutputsRef = useRef([])
    const modelRef = useRef(null)

    const [showWebCamModel, setShowWebCamModel] = useState(false)
    const [showAudioModel, setShowAudioModel] = useState(false)
    const [imageUpload, setImageUpload] = useState(false)
    const [isAudioUploadOpen, setAudioUploadOpen] = useState(false)
    const [selectedClass, setSelectedClass] = useState('')
    // In AI-code mode the image/audio split is passed as a prop (dedicated
    // routes) instead of the AppMode pathname check.
    const isAudioTrain =
        props.audioMode !== undefined
            ? props.audioMode
            : window.location.pathname === '/AudioTrainMachine'
    const aiCodeMode = props.aiCodeMode === true

    // In AI Studio only offer training for the vision A.I. features the user
    // actually picked on Select Feature (face/object/gesture/pose).
    const aiSelectedFeatures = (() => {
        if (!aiCodeMode) return null
        try {
            return (
                JSON.parse(
                    sessionStorage.getItem('aiCodeSelectedFeatures')
                ) || []
            )
        } catch {
            return []
        }
    })()
    const trainTypeAllowed = (type) => {
        if (!aiCodeMode) return !['object', 'gesture'].includes(type)
        return (aiSelectedFeatures || []).includes(`ai/${type}`)
    }

    // AI-code step nav labels for the shared ProgramHeader.
    const aiCodeHeaderData = {
        selected: 1,
        options: [
            <p key="select-feature">Select Feature</p>,
            <p key="configure">Configure</p>,
            <p key="code">Code</p>,
            <p key="execute">Execute</p>,
        ],
    }

    const [poseDetector, setPoseDetector] = useState(null)
    const [editingRegionId, setEditingRegionId] = useState(null)
    const [editingRegionName, setEditingRegionName] = useState('')

    // const { update, getAll, deleteRecord } = useIndexedDB('SavedFaces')
    const modelsDb = useIndexedDB('models')
    const samplesDb = useIndexedDB('Samples')

    const [startTraining, setStartTraining] = useState(false)
    // const [showAdvance, setShowAdvance] = useState(false)
    const [showEpochsHelp, setShowEpochsHelp] = useState(false)
    const [showBatchHelp, setShowBatchHelp] = useState(false)
    const [mainTab, setMainTab] = useState('train') // train | roi
    const [activeTab, setActiveTab] = useState('training')
    const [savedModels, setSavedModels] = useState([])
    const [savedModelsLoading, setSavedModelsLoading] = useState(false)
    const [showInputModelName, setShowInputModelName] = useState(false)
    const [modelName, setModelName] = useState('')
    const [modelNameError, setModelNameError] = useState('')
    const [editModelId, setEditModelId] = useState(null)
    const [editModelName, setEditModelName] = useState('')

    const [pendingTrain, setPendingTrain] = useState(false)
    const isSyncingRef = useRef(false)
    const [isSyncing, setIsSyncing] = useState(false)

    const [showModel, setShowModel] = useState({
        isShow: false,
        message: '',
        type: '',
    })

    const inputRef = useRef(null)
    const modelListRef = useRef(null)
    const autoSaveTimerRef = useRef(null)

    const currentModel = props.camModels?.find((model) => model?.modelId === props.currentModelId)
        ?? props.camModels?.[0]

    useEffect(() => {
        if (!props.camModels?.length) return
        const match = props.camModels.find((m) => m.modelId === props.currentModelId)
        if (!match) {
            props.setCurrentModelId(props.camModels[0].modelId)
        }
    }, [props.camModels, props.currentModelId])

    const roiRegions = Array.isArray(currentModel?.roiRegions)
        ? currentModel.roiRegions
        : []
    const [activeRegionId, setActiveRegionId] = useState(null)

    // A model's TYPE (what it recognises) maps to the training architecture.
    const TYPE_TO_ARCH = {
        face: 'cnn',
        object: 'cnn',
        gesture: 'hand',
        pose: 'pose',
    }
    const activeModelType =
        currentModel?.modelType ||
        (currentModel?.detectionType === 'pose'
            ? 'pose'
            : currentModel?.detectionType === 'hand'
            ? 'gesture'
            : 'face')
    // AI Studio: if the current model's type isn't a selected feature (e.g.
    // trained Face, then removed Face on Select Feature), snap it to the first
    // allowed type so the picker only ever shows chosen features.
    useEffect(() => {
        if (!aiCodeMode || startTraining) return
        const allowed = ['face', 'object', 'gesture', 'pose'].filter(
            trainTypeAllowed
        )
        if (allowed.length && !allowed.includes(activeModelType)) {
            handleModelTypeChange(allowed[0])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeModelType, aiCodeMode])

    // Classes are tagged with the type they were created under; legacy untagged
    // classes are treated as 'face'. The trainer and decision panel only ever
    // see the classes belonging to the active type.
    const classTypeOf = (c) => c?.classType || 'face'

    // Select classes based on training mode (audio or image), then scope image
    // classes to the active type so switching Face->Object shows a fresh set.
    const allImageClasses = currentModel?.ImageClasses || {}
    const typedImageClasses = Object.fromEntries(
        Object.entries(allImageClasses).filter(
            ([, c]) => classTypeOf(c) === activeModelType
        )
    )
    const classes = isAudioTrain
        ? currentModel?.AudioClasses || {}
        : typedImageClasses
    // Per-type trained flag so Next enables for the type actually trained.
    const isEnableNextBtn = isAudioTrain
        ? currentModel?.isGenerateTensor
        : currentModel?.trainedTypes?.[activeModelType] ||
          (activeModelType === 'face' && currentModel?.isGenerateTensor)
    const isShowClassDeleteBtn = Object.keys(classes).length > 1

    useEffect(() => {
        if (!currentModel) return

        if (autoSaveTimerRef.current) clearTimeout(autoSaveTimerRef.current)

        autoSaveTimerRef.current = setTimeout(async () => {
            try {
                await modelsDb.update({
                    id: currentModel.modelId,
                    modelName: currentModel.modelName,
                    epochs: currentModel.epochs || DEFAULT_EPOCHS,
                    batchSize: currentModel.batchSize || DEFAULT_BATCH_SIZE,
                    AudioClasses: currentModel.AudioClasses || {},
                    ImageClasses: currentModel.ImageClasses || {},
                    isGenerateTensor: currentModel.isGenerateTensor || false,
                    isSpeechCommandsModel: currentModel.isSpeechCommandsModel || false,
                    speechCommandsLabels: currentModel.speechCommandsLabels || [],
                    detectionType: currentModel.detectionType || 'cnn',
                    modelType: currentModel.modelType || 'face',
                    trainedTypes: currentModel.trainedTypes || {},
                    // KNN models store their class centroids here (no TF file).
                    knnCentroids: currentModel.knnCentroids || null,
                    isSavedModel: false,
                })
            } catch (e) {
                console.error('[AutoSave] Failed to persist model to IndexedDB:', e)
            }
        }, 1500)

        return () => {
            if (autoSaveTimerRef.current) clearTimeout(autoSaveTimerRef.current)
        }
    }, [currentModel])

    useJsPlumbConnections(
        classes,
        props.currentModelId,
        leftContainerRef,
        connectionContainerRef,
        jsPlumbInstance,
        mainTab,
        `${activeModelType}|${activeTab}|${isAudioTrain}`
    )
    const mobilenet = useMobilenetLoader()

    useEffect(() => {
        if (mobilenet && pendingTrain) {
            setPendingTrain(false)
            handelTrain()
        }
    }, [mobilenet, pendingTrain])

    useEffect(() => {
        if (mobilenet && showModel.type === 'error') {
            setShowModel({
                isShow: false,
                message: '',
                type: '',
            })
        }
    }, [mobilenet])

    useEffect(() => {
        if (currentModel?.detectionType === 'pose') {
            loadPoseModel()
        }
    }, [currentModel?.detectionType])

    useEffect(() => {
        if (!roiRegions.length) {
            setActiveRegionId(null)
            return
        }

        const exists = roiRegions.find((r) => r.id === activeRegionId)

        if (!exists) {
            setActiveRegionId(roiRegions[0].id)
        }
    }, [props.currentModelId, roiRegions])

    useEffect(() => {
        if (currentModel?.detectionType !== 'pose') return
        if (isSyncingRef.current) return

        const classes = Object.values(currentModel.ImageClasses || [])

        const hasImages = classes.some((c) => (c.capturedImages?.length > 0) || (c.capturedImagesCount > 0))

        const needsUpdate = classes.some(
            (c) =>
                (c.capturedImages?.length || c.capturedImagesCount || 0) !==
                (c.capturedPoses?.length || 0)
        )

        if (hasImages && needsUpdate) {
            console.log('Start syncing (UI immediately)')

            isSyncingRef.current = true
            setIsSyncing(true)

            generatePoseVectorsFromImages(currentModel).finally(() => {
                isSyncingRef.current = false
                setIsSyncing(false)
                console.log('Sync done')
            })
        }
    }, [
        currentModel?.ImageClasses,
        currentModel?.detectionType,
        poseDetector,
    ])

    const loadPoseModel = async () => {
        try {
            // MediaPipe Pose Landmarker (33 full-body landmarks). Preload so the
            // first capture is instant; a readiness flag replaces the old model.
            await getPoseLandmarker()
            setPoseDetector(true)
            console.log('Pose Landmarker loaded successfully')
        } catch (err) {
            console.error('Error loading pose model:', err)
        }
    }

    const capturePoseSample = async (videoElement, _imageSrc) => {
        if (!videoElement) return

        try {
            const landmarker = await getPoseLandmarker()
            const res = landmarker.detectForVideo(
                videoElement,
                nextVideoTimestamp(performance.now())
            )
            const pv = poseVectorFromResult(res)
            if (!pv || !pv.vector) {
                console.warn('No pose detected, skipping sample')
                return
            }
            // Feature vector: 33 landmarks * (x,y) = 66 values, hip-centred and
            // torso-scaled (see normalizePoseLandmarks).
            const featureVector = pv.vector

            // Full-frame snapshot for the class thumbnail / project bundle.
            const frameCanvas = document.createElement('canvas')
            frameCanvas.width = videoElement.videoWidth
            frameCanvas.height = videoElement.videoHeight
            const frameCtx = frameCanvas.getContext('2d')
            if (frameCtx)
                frameCtx.drawImage(
                    videoElement,
                    0,
                    0,
                    videoElement.videoWidth,
                    videoElement.videoHeight
                )
            const snapshot = frameCanvas.toDataURL('image/jpeg')

            if (!selectedClass) return

            props.savePoseSample(selectedClass, {
                poseVector: featureVector,
                snapshot: snapshot,
            })

            console.log('POSE SAVED', featureVector.length)
        } catch (err) {
            console.error('Pose capture error:', err)
        }
    }

    const checkAllSamples = (idxCountsByClass = {}) => {
        let issues = []

        for (const classKey in classes) {
            const classData = classes[classKey]

            // Use IndexedDB count as source of truth; fall back to Redux if available
            const reduxCount = classData?.capturedImagesCount ?? (classData?.capturedImages?.length ?? 0)
            const idxCount = idxCountsByClass[classKey] || 0
            const imageCount = Math.max(reduxCount, idxCount)
            const poses = classData?.capturedPoses || []

            if (!isAudioTrain && imageCount < 10) {
                issues.push({
                    classKey,
                    type: 'image',
                    count: imageCount,
                })
            }

            if (poses.length < 10) {
                issues.push({
                    classKey,
                    type: 'pose',
                    count: poses.length,
                })
            }
        }

        return issues
    }

    const cropVideoWithROI = (videoElement) => {
        const videoWidth = videoElement.videoWidth
        const videoHeight = videoElement.videoHeight

        if (!roiRegions?.length || !activeRegionId) {
            const canvas = document.createElement('canvas')
            canvas.width = videoWidth
            canvas.height = videoHeight
            canvas.getContext('2d').drawImage(videoElement, 0, 0)
            return canvas
        }

        const activeRegion = roiRegions.find((r) => r.id === activeRegionId)
        if (!activeRegion) return videoElement

        // If ground mode → warp
        if (activeRegion.mode === 'ground') {
            const imgCanvas = document.createElement('canvas')
            imgCanvas.width = videoWidth
            imgCanvas.height = videoHeight
            const ctx = imgCanvas.getContext('2d')
            ctx.drawImage(videoElement, 0, 0)

            return warpPerspectiveFromImage(imgCanvas, activeRegion)
        }

        // Rectangle mode
        const realX = activeRegion.xPercent * videoWidth
        const realY = activeRegion.yPercent * videoHeight
        const realW = activeRegion.widthPercent * videoWidth
        const realH = activeRegion.heightPercent * videoHeight

        const canvas = document.createElement('canvas')
        canvas.width = realW
        canvas.height = realH

        canvas
            .getContext('2d')
            .drawImage(
                videoElement,
                realX,
                realY,
                realW,
                realH,
                0,
                0,
                realW,
                realH
            )

        return canvas
    }

    const addRegion = () => {
        const regionWidth = 200
        const regionHeight = 200

        const CAM_HEIGHT = 550
        const CAM_WIDTH = 900

        const pixelX = CAM_WIDTH / 2 - regionWidth / 2
        const pixelY = CAM_HEIGHT - regionHeight - 20

        const newRegion = {
            id: Date.now(),
            name: `Region ${roiRegions.length + 1}`,
            mode: 'rectangle',

            // STORE AS PERCENT
            xPercent: pixelX / CAM_WIDTH,
            yPercent: pixelY / CAM_HEIGHT,
            widthPercent: regionWidth / CAM_WIDTH,
            heightPercent: regionHeight / CAM_HEIGHT,
            points: [],
        }

        setRoiRegions([...roiRegions, newRegion])
        setActiveRegionId(newRegion.id)
    }

    const checkImagePresent = () => {
        for (const classKey in classes) {
            const classData = classes?.[classKey]
            const imageCount = classData?.capturedImagesCount ?? (classData?.capturedImages?.length ?? 0)
            if (imageCount === 0) {
                return { status: true, classKey, imageNumber: 0 }
            }
            if (imageCount < 10) {
                return {
                    status: true,
                    classKey,
                    imageNumber: imageCount,
                }
            }
        }
        return {
            status: false,
            classKey: '',
            imageNumber: 11,
        }
    }

    const computeHomography = (src, dst) => {
        const A = []

        for (let i = 0; i < 4; i++) {
            const { x, y } = src[i]
            const { x: u, y: v } = dst[i]

            A.push([-x, -y, -1, 0, 0, 0, x * u, y * u, u])
            A.push([0, 0, 0, -x, -y, -1, x * v, y * v, v])
        }

        // Solve Ah = 0 using simple SVD substitute (numeric solve)
        const numeric = window.numeric
        const svd = numeric.svd(A)
        const h = svd.V[8]

        return [
            [h[0], h[1], h[2]],
            [h[3], h[4], h[5]],
            [h[6], h[7], h[8]],
        ]
    }

    const warpPerspectiveFromImage = (imgElement, region) => {
        if (!region.points || region.points.length !== 4) {
            return imgElement
        }

        const width = imgElement.width
        const height = imgElement.height
        const numeric = window.numeric

        const srcPts = region.points.map((p) => ({
            x: p.xPercent * width,
            y: p.yPercent * height,
        }))

        const outputWidth = 300
        const outputHeight = 300

        const dstPts = [
            { x: 0, y: 0 },
            { x: outputWidth, y: 0 },
            { x: outputWidth, y: outputHeight },
            { x: 0, y: outputHeight },
        ]

        const H = computeHomography(srcPts, dstPts)

        const canvas = document.createElement('canvas')
        canvas.width = outputWidth
        canvas.height = outputHeight

        const ctx = canvas.getContext('2d')
        const srcCanvas = document.createElement('canvas')
        srcCanvas.width = width
        srcCanvas.height = height
        const srcCtx = srcCanvas.getContext('2d')
        srcCtx.drawImage(imgElement, 0, 0)

        const srcData = srcCtx.getImageData(0, 0, width, height)
        const outputData = ctx.createImageData(outputWidth, outputHeight)

        const Hinv = numeric.inv(H)

        for (let y = 0; y < outputHeight; y++) {
            for (let x = 0; x < outputWidth; x++) {
                const denom = Hinv[2][0] * x + Hinv[2][1] * y + Hinv[2][2]

                const srcX =
                    (Hinv[0][0] * x + Hinv[0][1] * y + Hinv[0][2]) / denom
                const srcY =
                    (Hinv[1][0] * x + Hinv[1][1] * y + Hinv[1][2]) / denom

                const x0 = Math.floor(srcX)
                const y0 = Math.floor(srcY)
                const x1 = x0 + 1
                const y1 = y0 + 1

                const dstIndex = (y * outputWidth + x) * 4

                if (x0 >= 0 && y0 >= 0 && x1 < width && y1 < height) {
                    const dx = srcX - x0
                    const dy = srcY - y0

                    const idx00 = (y0 * width + x0) * 4
                    const idx10 = (y0 * width + x1) * 4
                    const idx01 = (y1 * width + x0) * 4
                    const idx11 = (y1 * width + x1) * 4

                    for (let c = 0; c < 3; c++) {
                        outputData.data[dstIndex + c] =
                            srcData.data[idx00 + c] * (1 - dx) * (1 - dy) +
                            srcData.data[idx10 + c] * dx * (1 - dy) +
                            srcData.data[idx01 + c] * (1 - dx) * dy +
                            srcData.data[idx11 + c] * dx * dy
                    }

                    outputData.data[dstIndex + 3] = 255
                }
            }
        }
        ctx.putImageData(outputData, 0, 0)

        return canvas
    }

    const cropImageWithROI = (imgElement) => {
        if (!roiRegions?.length) return imgElement
        if (!activeRegionId) return imgElement

        const activeRegion = roiRegions.find((r) => r.id === activeRegionId)
        if (!activeRegion) return imgElement

        if (activeRegion.mode === 'ground') {
            return warpPerspectiveFromImage(imgElement, activeRegion)
        }
        const width = imgElement.width
        const height = imgElement.height

        const realX = activeRegion.xPercent * width
        const realY = activeRegion.yPercent * height
        const realW = activeRegion.widthPercent * width
        const realH = activeRegion.heightPercent * height

        const canvas = document.createElement('canvas')
        canvas.width = realW
        canvas.height = realH

        const ctx = canvas.getContext('2d')

        ctx.drawImage(
            imgElement,
            realX,
            realY,
            realW,
            realH,
            0,
            0,
            realW,
            realH
        )

        return canvas
    }

    const base64toBlob = async (image) => {
        const byteCharacters = window.atob(image)
        const byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        const blob = new Blob([byteArray], { type: 'image/jpeg' })
        const blobUrl = URL.createObjectURL(blob)
        sessionStorage.setItem('img', blobUrl)
    }

    const trainCNNFromPoseData = async (modelData) => {
        const classes = Object.values(modelData.ImageClasses || [])

        let inputs = []
        let outputs = []
        let CLASS_NAMES = []
        let count = 0

        classes.forEach((eachClass) => {
            if (!eachClass.capturedPoses?.length) return

            CLASS_NAMES.push(eachClass.className)

            eachClass.capturedPoses.forEach((sample) => {
                inputs.push(sample.poseVector)
                outputs.push(count)
            })

            count++
        })

        if (inputs.length === 0) {
            setShowModel({
                isShow: true,
                message:
                    'No pose data available. Please capture pose samples before training.',
                type: 'error',
            })
            return
        }

        const xs = tf.tensor2d(inputs)
        const labelsTensor = tf.tensor1d(outputs, 'int32')
        const ys = tf.oneHot(labelsTensor, CLASS_NAMES.length)

        const model = tf.sequential()
        model.add(
            tf.layers.dense({
                inputShape: [inputs[0].length],
                units: 128,
                activation: 'relu',
            })
        )
        model.add(
            tf.layers.dense({
                units: CLASS_NAMES.length,
                activation: 'softmax',
            })
        )

        model.compile({
            optimizer: 'adam',
            loss: 'categoricalCrossentropy',
            metrics: ['accuracy'],
        })

        await model.fit(xs, ys, {
            epochs: modelData.epochs,
            batchSize: modelData.batchSize,
        })

        await model.save(`indexeddb://${modelData.modelId}`)

        console.log(
            `CNN (from Pose Data) Model "${modelData.modelName}" trained successfully`
        )

        xs.dispose()
        ys.dispose()
        model.dispose()

        let updatedModels = [...props.camModels]
        const index = updatedModels.findIndex(
            (m) => m.modelId === modelData.modelId
        )

        if (index !== -1) {
            updatedModels[index].isGenerateTensor = true
            updatedModels[index].classLabels = CLASS_NAMES
        }

        props.setModelDetails(updatedModels)
    }

    const generatePoseVectorsFromImages = async (modelData) => {
        // MediaPipe Pose Landmarker (IMAGE mode) turns each stored frame into a
        // 66-value landmark vector.
        const landmarker = await getPoseLandmarkerImage()

        console.log('==== BEFORE GENERATION ====')

        const updatedClasses = { ...modelData.ImageClasses }

        for (let key in updatedClasses) {
            const eachClass = updatedClasses[key]

            if (!eachClass.capturedImages?.length) continue

            eachClass.isSyncing = true
        }

        props.renamePoseClass({
            data: { ...updatedClasses },
            classType: 'ImageClasses',
        })

        await new Promise((res) => setTimeout(res, 0))

        for (let key in modelData.ImageClasses) {
            const c = modelData.ImageClasses[key]
            console.log(
                c.className,
                'images:',
                c.capturedImages?.length,
                'poses:',
                c.capturedPoses?.length
            )
        }

        for (let key in updatedClasses) {
            const eachClass = updatedClasses[key]

            if (!eachClass.capturedImages?.length) continue

            if (!eachClass.capturedPoses) {
                eachClass.capturedPoses = []
            }

            // FIX MISMATCH
            if (
                eachClass.capturedPoses.length > eachClass.capturedImages.length
            ) {
                eachClass.capturedPoses = eachClass.capturedPoses.slice(
                    0,
                    eachClass.capturedImages.length
                )
            }

            const existingPoses = eachClass.capturedPoses

            for (
                let i = existingPoses.length;
                i < eachClass.capturedImages.length;
                i++
            ) {
                await new Promise((res) => setTimeout(res, 0))
                const image = eachClass.capturedImages[i]

                console.log('Processing image:', image)

                const img = new Image()
                img.src = image

                await new Promise((res) => {
                    img.onload = res
                })

                const croppedImg = cropImageWithROI(img)

                const res = landmarker.detect(croppedImg)
                const pv = poseVectorFromResult(res)
                if (!pv || !pv.vector) {
                    console.warn('No pose in image, skipping sample')
                    continue
                }

                eachClass.capturedPoses.push({
                    poseVector: pv.vector,
                    snapshot: image,
                })
            }
            console.log(
                `Generated ${eachClass.capturedPoses.length} pose vectors for class "${eachClass.className}"`
            )

            eachClass.isSyncing = false

            props.renamePoseClass({
                data: { ...updatedClasses },
                classType: 'ImageClasses',
            })
        }
        props.renamePoseClass({
            data: updatedClasses,
            classType: 'ImageClasses',
        })

        await new Promise((res) => setTimeout(res, 50))
        return updatedClasses
    }

    // Gesture training: convert each captured image into a normalized hand-
    // landmark vector (MediaPipe) and store it in capturedPoses, so the shared
    // pose classifier head can train on hand shapes. Mirrors the pose flow.
    const generateHandVectorsFromImages = async (modelData) => {
        const recognizer = await getGestureRecognizerImage()
        const updatedClasses = { ...modelData.ImageClasses }

        for (let key in updatedClasses) {
            const eachClass = updatedClasses[key]
            if (!eachClass.capturedImages?.length) continue
            if (!eachClass.capturedPoses) eachClass.capturedPoses = []
            if (
                eachClass.capturedPoses.length > eachClass.capturedImages.length
            ) {
                eachClass.capturedPoses = eachClass.capturedPoses.slice(
                    0,
                    eachClass.capturedImages.length
                )
            }
            for (
                let i = eachClass.capturedPoses.length;
                i < eachClass.capturedImages.length;
                i++
            ) {
                await new Promise((res) => setTimeout(res, 0))
                const image = eachClass.capturedImages[i]
                const img = new Image()
                img.src = image
                await new Promise((res) => {
                    img.onload = res
                })
                try {
                    const result = recognizer.recognize(img)
                    const hand = handVectorFromResult(result)
                    if (hand && hand.vector) {
                        eachClass.capturedPoses.push({
                            poseVector: hand.vector,
                            snapshot: image,
                        })
                    }
                } catch (e) {
                    console.warn('[aiCode] hand vector extract failed', e)
                }
            }
            props.renamePoseClass({
                data: { ...updatedClasses },
                classType: 'ImageClasses',
            })
        }
        props.renamePoseClass({
            data: updatedClasses,
            classType: 'ImageClasses',
        })
        await new Promise((res) => setTimeout(res, 50))
        return updatedClasses
    }

    const saveRegionName = (id) => {
        if (!editingRegionName.trim()) {
            setEditingRegionId(null)
            return
        }

        const updated = roiRegions.map((r) =>
            r.id === id ? { ...r, name: editingRegionName.trim() } : r
        )

        setRoiRegions(updated)

        setEditingRegionId(null)
    }

    /**
     * Handles training process for all camera models sequentially.
     * For audio training: uses HEAD's complete speech commands pipeline.
     * For image training: if pose detection type, use trainPoseModel; else use CNN training.
     */
    const handelTrain = async () => {
        try {
            if (startTraining || Object.keys(classes).length < 2) {
                return
            }
            // Heal a corrupted TF.js weights DB (missing object stores) before
            // saving, so model.save() can't crash with a NotFoundError.
            await repairTfjsDb()

            if (isAudioTrain) {
                // Audio training path (HEAD)
                let checkData = await checkSamplesPresent(
                    classes,
                    samplesDb,
                    props.currentModelId,
                    isAudioTrain
                )
                if (checkData.status) {
                    let popupText = ''
                    const minSamples = 10
                    if (checkData.sampleNumber === 0) {
                        popupText = `${
                            classes[checkData.classKey].className
                        } has no sample.`
                    } else {
                        popupText = `${
                            classes[checkData.classKey].className
                        } has fewer than ${minSamples} samples. A minimum of ${minSamples} samples is required for training.`
                    }
                    setShowModel({
                        isShow: true,
                        message: popupText,
                        type: 'showMessage',
                    })
                    return
                }

                /** Add a new model record to IndexedDB */
                const newModel = {
                    id: currentModel.modelId,
                    modelName: currentModel.modelName,
                    epochs: currentModel.epochs,
                    batchSize: currentModel.batchSize,
                    isGenerateTensor: true,
                    ImageClasses: currentModel.ImageClasses,
                    AudioClasses: currentModel.AudioClasses,
                }
                await modelsDb.update(newModel)

                setStartTraining(true)
                let classesInfo = []
                const allSamples = await samplesDb.getAll()

                for (let classKey in classes) {
                    let eachClass = classes[classKey]
                    let classSamples = allSamples
                        .filter(
                            (s) =>
                                s.modelId === props.currentModelId &&
                                String(s.classId) === String(classKey) &&
                                s.sampleType !== 'Image'
                        )
                        .map((s) => s.sampleData)

                    let allTensor = []

                    // sampleData is stored as { data: Float32Array, frameSize: 232 }.
                    const TARGET_LENGTH = 39904 // 172 frames × 232 bins
                    allTensor = classSamples.map((s) => {
                        const raw = s.data || s
                        if (!Array.isArray(raw) && !(raw instanceof Float32Array)) return null

                        const floatData = raw instanceof Float32Array ? raw : new Float32Array(raw)
                        if (floatData.length === TARGET_LENGTH) return floatData

                        if (floatData.length < TARGET_LENGTH) {
                            const padded = new Float32Array(TARGET_LENGTH).fill(-100)
                            padded.set(floatData)
                            return padded
                        }
                        return floatData.slice(0, TARGET_LENGTH)
                    }).filter(d => d !== null)

                    if (allTensor.length > 0) {
                        classesInfo.push({
                            id: String(classKey),
                            imagetensors: allTensor,
                            categoryName: eachClass.CategoryName || 'Non Human',
                        })
                    }
                }

                await new Promise((resolve) => setTimeout(resolve, 100))
                await trainWithSpeechCommands(classesInfo)
                return
            }

            // Image training path
            if (!currentModel || startTraining) return

            if (isSyncingRef.current) {
                setShowModel({
                    isShow: true,
                    message: 'Please wait, pose samples are updating...',
                    type: 'loading',
                })
                return
            }

            if (
                (currentModel?.detectionType === 'cnn' ||
                    currentModel?.detectionType === 'knn') &&
                !mobilenet
            ) {
                setPendingTrain(true)
                setShowModel({
                    isShow: true,
                    message: 'Feature extractor is still loading. Please wait...',
                    type: 'error',
                })
                return
            }

            // Only the active type's classes are trained.
            const classesArr = Object.values(typedImageClasses || {})

            if (classesArr.length < 2) {
                setShowModel({
                    isShow: true,
                    message: 'Minimum 2 classes required to proceed',
                    type: 'error',
                })
                return
            }

            const detectionArch = currentModel.detectionType
            // Each type gets its own trained head so a model can hold e.g. both
            // a face and an object classifier without one clobbering the other.
            const saveKey = `${currentModel.modelId}__${activeModelType}`

            // Load images from IndexedDB — used for both validation and training
            const allSamplesForTrain = await samplesDb.getAll()
            const modelSamples = allSamplesForTrain.filter(
                (s) => s.modelId === currentModel.modelId && s.sampleType === 'Image'
            )

            // Build per-class IndexedDB counts for accurate validation
            const idxCountsByClass = {}
            for (const s of modelSamples) {
                idxCountsByClass[s.classId] = (idxCountsByClass[s.classId] || 0) + 1
            }

            const issues = checkAllSamples(idxCountsByClass)

            if (issues.length > 0) {
                // Every type is trained from captured IMAGES — pose/gesture
                // convert those images to landmark vectors at train time, so the
                // captured-pose count is 0 until then. Validate on images only.
                const hasImageIssue = issues.some((i) => i.type === 'image')
                if (hasImageIssue) {
                    setShowModel({
                        isShow: true,
                        message:
                            'Minimum 10 samples required per class for better accuracy',
                        type: 'error',
                    })
                    return
                }
            }
            // Build the training set from ONLY the active type's classes.
            const enrichedImageClasses = { ...typedImageClasses }
            for (const key in enrichedImageClasses) {
                const classData = enrichedImageClasses[key]
                const classSamples = modelSamples
                    .filter((s) => String(s.classId) === String(key))
                    .map((s) => s.sampleData)
                enrichedImageClasses[key] = {
                    ...classData,
                    capturedImages: classSamples.length > 0 ? classSamples : (classData.capturedImages || []),
                }
            }
            const enrichedModel = {
                ...currentModel,
                ImageClasses: enrichedImageClasses,
                // The train modules save the head to `saveKey` and mark this
                // type as trained (trainedTypes) rather than a single flag.
                saveKey,
                trainedType: activeModelType,
            }

            const classesForTrain = Object.values(enrichedModel.ImageClasses || [])

            if (classesForTrain.length < 2) return

            setStartTraining(true)

            try {
                if (detectionArch === 'knn') {
                    await trainKnnModel({
                        modelData: enrichedModel,
                        mobilenet,
                        camModels: props.camModels,
                        setModelDetails: props.setModelDetails,
                    })
                } else if (detectionArch === 'cnn') {
                    const hasImages = classesForTrain.some(
                        (c) => (c.capturedImages?.length > 0) || (c.capturedImagesCount > 0)
                    )
                    const hasPoses = classesForTrain.some(
                        (c) => c.capturedPoses?.length > 0
                    )

                    if (hasImages) {
                        await trainSingleModel({
                            modelData: enrichedModel,
                            mobilenet,
                            camModels: props.camModels,
                            setModelDetails: props.setModelDetails,
                        })
                    } else if (hasPoses) {
                        await trainCNNFromPoseData(enrichedModel)
                    } else {
                        throw new Error('No training data found')
                    }
                } else if (detectionArch === 'hand') {
                    // Gesture: convert captured images to hand-landmark vectors,
                    // then train the shared landmark classifier head.
                    const hasImages = classesForTrain.some(
                        (c) => (c.capturedImages?.length > 0) || (c.capturedImagesCount > 0)
                    )
                    const hasPoses = classesForTrain.some(
                        (c) => c.capturedPoses?.length > 0
                    )
                    let updatedModel = enrichedModel
                    if (hasImages) {
                        const updatedClasses =
                            await generateHandVectorsFromImages(enrichedModel)
                        updatedModel = {
                            ...enrichedModel,
                            ImageClasses: updatedClasses,
                        }
                    } else if (!hasPoses) {
                        throw new Error('No training data found')
                    }
                    await trainPoseModel({
                        modelData: updatedModel,
                        camModels: props.camModels,
                        setModelDetails: props.setModelDetails,
                    })
                } else {
                    const hasPoses = classesForTrain.some(
                        (c) => c.capturedPoses?.length > 0
                    )
                    const hasImages = classesForTrain.some(
                        (c) => (c.capturedImages?.length > 0) || (c.capturedImagesCount > 0)
                    )

                    if (hasPoses) {
                        await trainPoseModel({
                            modelData: enrichedModel,
                            camModels: props.camModels,
                            setModelDetails: props.setModelDetails,
                        })
                    } else if (hasImages) {
                        const updatedClasses =
                            await generatePoseVectorsFromImages(enrichedModel)

                        const updatedModel = {
                            ...enrichedModel,
                            ImageClasses: updatedClasses,
                        }

                        await trainPoseModel({
                            modelData: updatedModel,
                            camModels: props.camModels,
                            setModelDetails: props.setModelDetails,
                        })
                    } else {
                        throw new Error('No training data found')
                    }
                }

                setShowModel({
                    isShow: true,
                    message: `Model "${currentModel.modelName}" trained successfully!`,
                    type: 'trainSuccessful',
                    optionsToSelect: getModelOptions('trainSuccessful'),
                })
            } catch (err) {
                console.error(err)
                setShowModel({
                    isShow: true,
                    message: 'Model training was fail.',
                    type: 'showMessage',
                })
            }

            setStartTraining(false)
        } catch (e) {
            setStartTraining(false)
            setShowModel({
                isShow: true,
                message: 'Model training was fail.',
                type: 'showMessage',
            })
            console.error('ERROR', e)
        }
    }

    const addClass = () => {
        try {
            if (isAudioTrain) {
                // Get all class names
                const existingClassNumbers = Object.values(classes).map((cls) => {
                    const match = cls.className?.match(/Class_(\d+)/)
                    return match ? parseInt(match[1]) : 1
                })

                const nextClassNumber =
                    existingClassNumbers.length > 1
                        ? Math.max(...existingClassNumbers) + 1
                        : 1

                const className = `Class_${nextClassNumber}`
                const newKey = randomNumberGenerator()

                const data = {
                    id: newKey,
                    className,
                    sampleType: 'Audio',
                    capturedAudio: [],
                    capturedAudioCount: 0,
                }

                props.setNewClasses({
                    key: newKey,
                    data,
                    classType: 'AudioClasses',
                })
            } else {
                // Class keys must be unique across ALL image classes (every
                // type shares the ImageClasses dict), so number from the full
                // set — not the type-filtered `classes`.
                const allKeys = Object.keys(allImageClasses || {})
                let maxNum = 0
                allKeys.forEach((k) => {
                    const n = parseInt(k.split('_')?.[1] || '0')
                    if (n > maxNum) maxNum = n
                })
                const classLastNumber = maxNum + 1

                let data = {
                    id: Date.now(),
                    className: 'Class ' + classLastNumber,
                    sampleType: 'Image',
                    indexedDbId: 'Class ' + classLastNumber,
                    // The type this class belongs to; the trainer/panel only
                    // show classes of the active type.
                    classType: activeModelType,
                    capturedImages: [],
                    capturedPoses: [],
                    bgColor:
                        '#' + Math.floor(Math.random() * 16777215).toString(16),
                }

                props.setNewClasses({
                    key: 'Class_' + classLastNumber,
                    data,
                    classType: 'ImageClasses',
                })

                autoScrollLeftContainer()
            }
        } catch (e) {
            console.error('ERROR', e)
        }
    }

    const webCamModelHandel = ({ value, imageUpload, classesObjectKey }) => {
        setShowWebCamModel(value)
        setImageUpload(imageUpload)
        setSelectedClass(classesObjectKey)
    }

    const audioModelHandel = ({ value, audioUpload, className }) => {
        setShowAudioModel(value)
        if (className !== undefined) {
            setSelectedClass(className)
        }
        setAudioUploadOpen(audioUpload)
    }

    //handel change the oninput change of advance setting
    const handelAdvanceChange = (e, key) => {
        const parsed = parseInt(e.target.value, 10)
        if (isNaN(parsed) || parsed < 1) return  // ignore invalid/empty input
        let advanceSetting = {
            epochs: currentModel.epochs,
            batchSize: currentModel.batchSize,
        }
        advanceSetting[key] = parsed
        props.setAdvanceSetting(advanceSetting)
    }

    //reset the advance setting state
    const handelReset = () => {
        props.setAdvanceSetting({
            epochs: DEFAULT_EPOCHS,
            batchSize: DEFAULT_BATCH_SIZE,
        })
    }

    //handel next button click
    const nextButtonHandel = () => {
        if (isEnableNextBtn) {
            let enable = JSON.parse(sessionStorage.getItem('enable'))

            // AI-code mode stays inside the AI-code routes.
            if (aiCodeMode) {
                enable = {
                    ...enable,
                    s2: { emotion: false, face: true, object: false },
                }
                sessionStorage.setItem('enable', JSON.stringify(enable))
                // Embedded in AiConfigure: advance to the next Configure tab
                // instead of leaving to the flow route.
                if (typeof props.onNext === 'function') {
                    props.onNext()
                    return
                }
                if (!isAudioTrain && enable?.s1?.mic === true) {
                    history.push('/aiCodeConfigureAudio')
                    return
                }
                history.push('/aiCodeFlow')
                return
            }

            // Flow: ImageTrainMachine → AudioTrainMachine (if mic selected) → programmingPage
            if (!isAudioTrain && enable?.s1?.mic === true) {
                history.push('/AudioTrainMachine')
                return
            }

            enable = {
                ...enable,
                s2: {
                    emotion: false,
                    face: true,
                    object: false,
                },
            }

            sessionStorage.setItem('enable', JSON.stringify(enable))
            history.push('/programmingPage')
        }
    }

    const handelGoNext = () => {
        setShowModel({ isShow: false, message: '', type: '' })
        nextButtonHandel()
    }

    const getModelOptions = (type) => {
        if (type === 'trainSuccessful') {
            return [
                {
                    text: 'Next',
                    do: () => handelGoNext(),
                },
            ]
        }
        return []
    }

    const validateModelNameExists = (name, modelId) => {
        const trimmed = name.trim()
        const exists = props.camModels.find(
            (ele) => ele.modelName.trim().toLowerCase() === trimmed.toLowerCase()
        )
        if (exists && exists.modelId !== modelId) return { message: 'Model name already exists', error: true }
        if (exists && exists.modelId === modelId) return { message: 'Model name already exists', error: false }
        return { message: '', error: false }
    }

    const addModel = () => {
        const newModelId = randomNumberGenerator()
        const defaults = createDefaultAudioClasses()
        const newModel = {
            modelId: newModelId,
            modelName: modelName.trim(),
            epochs: DEFAULT_EPOCHS,
            batchSize: DEFAULT_BATCH_SIZE,
            ImageClasses: {},
            AudioClasses: isAudioTrain ? defaults : {},
            isGenerateTensor: false,
            detectionType: currentModel?.detectionType || 'cnn',
            roiRegions: [],
        }
        props.setModelDetails([...props.camModels, newModel])
        props.setCurrentModelId(newModelId)
        setActiveTab('training')
    }

    const handelChangeModelName = (e) => setModelName(e.target.value)

    const handleModelTypeChange = async (modelType) => {
        if (startTraining) return

        let modelList = [...props.camModels]

        const index = modelList.findIndex(
            (m) => m.modelId === props.currentModelId
        )

        if (index === -1) return

        // Classes are type-scoped, so switching type just changes which set is
        // shown/trained — no need to touch the other types' classes or vectors.
        modelList[index] = {
            ...modelList[index],
            modelType,
            detectionType: TYPE_TO_ARCH[modelType],
        }

        props.setModelDetails(modelList)
    }

    const setRoiRegions = (updatedRegions) => {
        const updatedModels = [...props.camModels]

        const index = updatedModels.findIndex(
            (m) => m.modelId === props.currentModelId
        )

        if (index === -1) return

        updatedModels[index] = {
            ...updatedModels[index],
            roiRegions: updatedRegions,
        }

        props.setModelDetails(updatedModels)
    }

    const deleteRegion = (id) => {
        const currentIndex = roiRegions.findIndex((r) => r.id === id)
        if (currentIndex === -1) return

        const updated = roiRegions.filter((r) => r.id !== id)

        setRoiRegions(updated)

        // If deleted region was active
        if (activeRegionId === id) {
            if (updated.length === 0) {
                setActiveRegionId(null)
                return
            }

            // Select previous region if possible
            const newIndex = currentIndex - 1 >= 0 ? currentIndex - 1 : 0

            setActiveRegionId(updated[newIndex].id)
        }
    }

    //delete model
    const handelDeleteModel = async (deleteModelId) => {
        let modelList = props.camModels

        if (modelList.length === 1) {
            return
        }

        // find index of model to delete
        const deleteIndex = modelList.findIndex(
            (ele) => ele.modelId === deleteModelId
        )

        if (deleteIndex === -1) return // model not found

        // delete tensors if present in db
        const deleteModel = modelList[deleteIndex]
        if (deleteModel.isGenerateTensor && deleteModel.ImageClasses) {
            await modelsDb.deleteRecord(deleteModelId)
            try { await tf.io.removeModel(`indexeddb://${deleteModelId}`) } catch (_) {}
            try { await tf.io.removeModel(`indexeddb://${deleteModelId}_audio`) } catch (_) {}
        }

        // remove the model from the list
        modelList = modelList.filter((ele) => ele.modelId !== deleteModelId)

        const currentModelId = currentModel.modelId

        if (currentModelId === deleteModelId) {
            let newCurrentModelId = null

            // try to pick the next model
            if (modelList[deleteIndex]) {
                newCurrentModelId = modelList[deleteIndex].modelId
            }

            // else pick the previous one
            else if (modelList[deleteIndex - 1]) {
                newCurrentModelId = modelList[deleteIndex - 1].modelId
            }

            // set new current model in redux
            if (newCurrentModelId) {
                props.setCurrentModelId(newCurrentModelId)
            }
        }
        props.setModelDetails(modelList)
    }

    //copy the model
    const handelCopyModel = async (copyModel) => {
        let modelList = [...props.camModels]

        // get all model names
        const existingNames = modelList.map((m) => m.modelName)

        // base name for copy
        const baseName = `${copyModel.modelName}_Copy`
        let finalName = baseName

        // check if same name already exists
        let counter = 1
        while (existingNames.includes(finalName)) {
            counter++
            finalName = `${baseName}_${counter}`
        }

        // generate new model id
        const newModelId = Date.now()

        const newModel = {
            ...copyModel,
            ImageClasses: structuredClone(copyModel.ImageClasses),
            modelId: newModelId,
            modelName: finalName,
            detectionType: copyModel.detectionType || 'cnn',
            isGenerateTensor: false,
            roiRegions: structuredClone(copyModel.roiRegions || []),
        }

        modelList.push(newModel)

        props.setModelDetails(modelList)
    }

    //handel model edit button click
    const editBtnClick = (editModel) => {
        setEditModelId(editModel.modelId)
        setEditModelName(editModel.modelName)
    }

    const commitRename = () => {
        const trimmed = editModelName.trim()
        if (!trimmed) { setEditModelId(null); return }
        const err = validateModelName(trimmed)
        if (err) { setModelNameError(err); setTimeout(() => setModelNameError(''), 2000); return }
        const { error, message } = validateModelNameExists(trimmed, editModelId)
        if (error) { setModelNameError(message); setTimeout(() => setModelNameError(''), 2000); return }
        const updated = props.camModels.map((m) =>
            m.modelId === editModelId ? { ...m, modelName: trimmed } : m
        )
        props.setModelDetails(updated)
        setEditModelId(null)
        setEditModelName('')
    }

    const saveWorkingModel = async (model, e) => {
        e.stopPropagation()
        try {
            await modelsDb.update({
                id: model.modelId,
                modelName: model.modelName,
                epochs: model.epochs || DEFAULT_EPOCHS,
                batchSize: model.batchSize || DEFAULT_BATCH_SIZE,
                AudioClasses: model.AudioClasses || {},
                ImageClasses: model.ImageClasses || {},
                isGenerateTensor: model.isGenerateTensor || false,
                isSpeechCommandsModel: model.isSpeechCommandsModel || false,
                speechCommandsLabels: model.speechCommandsLabels || [],
                isSavedModel: true,
            })
            // Refresh the saved models list so it appears immediately
            loadSavedModels()
        } catch (err) {
            console.error('Error saving model:', err)
        }
    }

    const deleteWorkingModel = async (deleteModelId) => {
        if (props.camModels.length === 1) return

        const deleteIndex = props.camModels.findIndex((m) => m.modelId === deleteModelId)
        if (deleteIndex === -1) return

        const allSamples = await samplesDb.getAll()
        for (const s of allSamples.filter((s) => s.modelId === deleteModelId)) {
            await samplesDb.deleteRecord(s.id)
        }
        try { await tf.io.removeModel(`indexeddb://${deleteModelId}`) } catch (_) {}
        try { await tf.io.removeModel(`indexeddb://${deleteModelId}_audio`) } catch (_) {}
        try { await modelsDb.deleteRecord(deleteModelId) } catch (_) {}

        const remaining = props.camModels.filter((m) => m.modelId !== deleteModelId)
        props.setModelDetails(remaining)
        if (currentModel?.modelId === deleteModelId) {
            const next = remaining[deleteIndex] ?? remaining[deleteIndex - 1]
            if (next) props.setCurrentModelId(next.modelId)
        }
    }

    useEffect(() => {
        if (showInputModelName && modelListRef.current) {
            setTimeout(() => {
                modelListRef.current.scrollTo({ top: modelListRef.current.scrollHeight, behavior: 'smooth' })
            }, 100)
        }
    }, [showInputModelName])

    const loadSavedModels = async () => {
        setSavedModelsLoading(true)
        try {
            const all = await modelsDb.getAll()
            setSavedModels(all.filter((m) => m.isSavedModel === true))
        } catch (e) {
            console.error('Error loading saved models:', e)
        } finally {
            setSavedModelsLoading(false)
        }
    }

    const loadSavedModel = async (savedModel) => {
        try {
            // Create a working COPY with a new ID — the original saved record stays
            // untouched in IndexedDB so it continues to appear in Saved Models.
            const newModelId = randomNumberGenerator()

            const audioClasses =
                savedModel.AudioClasses &&
                Object.keys(savedModel.AudioClasses).length > 0
                    ? savedModel.AudioClasses
                    : createDefaultAudioClasses()

            const workingModel = {
                modelId: newModelId,
                modelName: savedModel.modelName,
                epochs: savedModel.epochs || DEFAULT_EPOCHS,
                batchSize: savedModel.batchSize || DEFAULT_BATCH_SIZE,
                AudioClasses: audioClasses,
                ImageClasses: savedModel.ImageClasses || {},
                isGenerateTensor: savedModel.isGenerateTensor || false,
                isSpeechCommandsModel: savedModel.isSpeechCommandsModel || false,
                speechCommandsLabels: savedModel.speechCommandsLabels || [],
                detectionType: savedModel.detectionType || 'cnn',
                modelType: savedModel.modelType,
                roiRegions: structuredClone(savedModel.roiRegions || []),
            }

            // Copy samples from the saved model to the new working model so that
            // the class recordings are available for training.
            const allSamples = await samplesDb.getAll()
            const modelSamples = allSamples.filter((s) => s.modelId === savedModel.id)
            for (const s of modelSamples) {
                await samplesDb.add({
                    classId: s.classId,
                    modelId: newModelId,
                    sampleData: s.sampleData,
                    sampleType: s.sampleType,
                })
            }

            // Copy the trained weights too so the model loads ready-to-use — no
            // retrain needed. The saved tensors stay under their own id.
            if (savedModel.isGenerateTensor) {
                try { await tf.io.copyModel(`indexeddb://${savedModel.id}`, `indexeddb://${newModelId}`) } catch (_) {}
                try { await tf.io.copyModel(`indexeddb://${savedModel.id}_audio`, `indexeddb://${newModelId}_audio`) } catch (_) {}
            }

            // Register the new working model in IndexedDB (auto-save will maintain it).
            await modelsDb.add({
                id: newModelId,
                ...workingModel,
                isSavedModel: false,
            })

            // Replace the active working model in place rather than appending, so
            // the Current Session doesn't accumulate a duplicate every time a saved
            // model is opened. Other session models are left untouched.
            const models = [...props.camModels]
            const activeIndex = models.findIndex((m) => m.modelId === props.currentModelId)
            if (activeIndex === -1) {
                models.push(workingModel)
            } else {
                models[activeIndex] = workingModel
            }
            props.setModelDetails(models)
            props.setCurrentModelId(newModelId)
            setActiveTab('training')
        } catch (e) {
            console.error('Error loading saved model:', e)
        }
    }

    const deleteSavedModel = async (modelId, e) => {
        e.stopPropagation()
        try {
            await modelsDb.deleteRecord(modelId)
            const allSamples = await samplesDb.getAll()
            for (const s of allSamples.filter((s) => s.modelId === modelId)) {
                await samplesDb.deleteRecord(s.id)
            }
            try { await tf.io.removeModel(`indexeddb://${modelId}`) } catch (_) {}
            try { await tf.io.removeModel(`indexeddb://${modelId}_audio`) } catch (_) {}
            setSavedModels((prev) => prev.filter((m) => m.id !== modelId))
        } catch (e) {
            console.error('Error deleting saved model:', e)
        }
    }

    useEffect(() => {
        if (activeTab === 'models') loadSavedModels()
    }, [activeTab])

    // Auto-scroll smoothly when add new class left side class container
    const autoScrollLeftContainer = () => {
        if (classes && leftContainerRef.current) {
            setTimeout(() => {
                leftContainerRef.current.scrollTo({
                    top: leftContainerRef.current.scrollHeight,
                    behavior: 'smooth',
                })
            }, 100)
        }
    }

    /**
     * Audio training using TensorFlow Speech Commands transfer learning.
     *
     * Injects stored spectrogram data into the BROWSER_FFT transfer recognizer
     * and trains a new classification head on top of the frozen base model.
     * The dataset's built-in windowing slices each 172-frame sample into
     * multiple 43-frame windows, and z-normalisation is applied automatically.
     */
    const trainWithSpeechCommands = async (classesInfo) => {
        setStartTraining(true)
        try {
            // Start from a FRESH transfer recognizer each train. A cached one
            // keeps the classification head from the previous train, so adding a
            // class (e.g. going 3 -> 4) crashed with a shape mismatch (16,5 vs
            // 16,4). And because the speech-commands library keeps an internal
            // registry of transfer-model NAMES, reusing the same name throws
            // "already exists" on the second train. freshTransferRecognizer gives
            // a uniquely-named, brand-new recognizer; examples are re-injected
            // from storage below, so nothing is lost.
            const transferRecognizer = await freshTransferRecognizer(
                currentModel.modelId
            )

            // Fully reset the dataset before injecting new examples.
            transferRecognizer.dataset.examples = {}
            transferRecognizer.dataset.label2Ids = {}
            transferRecognizer.words = null

            // Inject stored spectrograms into the transfer recognizer's dataset.
            for (const ci of classesInfo) {
                const label = String(ci.id)
                for (const rawSample of ci.imagetensors) {
                    const data = rawSample.data || rawSample
                    transferRecognizer.dataset.addExample({
                        label,
                        spectrogram: {
                            data: data instanceof Float32Array ? data : new Float32Array(data),
                            frameSize: 232,
                        },
                    })
                }
            }

            // Sync word labels from the dataset before calling train()
            transferRecognizer.collateTransferWords()

            await transferRecognizer.train({
                epochs: currentModel.epochs || DEFAULT_EPOCHS,
                batchSize: currentModel.batchSize || DEFAULT_BATCH_SIZE,
                validationSplit: 0.15,
                callback: {
                    onEpochEnd: (epoch, logs) =>
                        console.log(`[speech_commands] Epoch ${epoch}`, logs),
                },
            })

            await transferRecognizer.save(`indexeddb://${currentModel.modelId}_audio`)

            const speechCommandsLabels = transferRecognizer.wordLabels()

            const updatedModels = props.camModels.map((m) =>
                m.modelId === currentModel.modelId
                    ? {
                          ...m,
                          isGenerateTensor: true,
                          isSpeechCommandsModel: true,
                          speechCommandsLabels,
                      }
                    : m
            )

            await modelsDb.update({
                id: currentModel.modelId,
                modelName: currentModel.modelName,
                isGenerateTensor: true,
                isSpeechCommandsModel: true,
                speechCommandsLabels,
                AudioClasses: currentModel.AudioClasses,
            })

            props.setModelDetails(updatedModels)
            props.setToggleNextBtn(true)

            setShowModel({
                isShow: true,
                message: 'Model training was successful.',
                type: 'trainSuccessful',
                optionsToSelect: getModelOptions('trainSuccessful'),
            })
        } catch (e) {
            console.error('Speech commands transfer learning error:', e)
            setShowModel({
                isShow: true,
                message: 'Model training failed.',
                type: 'showMessage',
            })
        } finally {
            setStartTraining(false)
        }
    }

    const prepareModelForTraining = async (classesInfo) => {
        classNamesRef.current = []
        trainingDataInputsRef.current = []
        trainingDataOutputsRef.current = []

        let classIndex = 0

        classesInfo.forEach((eachClassInfo) => {
            classNamesRef.current.push(eachClassInfo.id)

            const samples = eachClassInfo.imagetensors || []

            samples.forEach((tensor) => {
                let rawData = isAudioTrain ? tensor.data || tensor : tensor
                if (!rawData || !Array.isArray(rawData)) {
                    console.warn('Skipping invalid sample data')
                    return
                }
                const normalized = isAudioTrain
                    ? rawData.map((val) => (val + 100) / 100)
                    : rawData

                trainingDataInputsRef.current.push(normalized)
                trainingDataOutputsRef.current.push(classIndex)
            })

            classIndex++
        })

        if (trainingDataInputsRef.current.length === 0) {
            throw new Error('No training data found')
        }

        const expectedLength = trainingDataInputsRef.current[0].length

        // Filter to keep only samples matching expected length
        const filteredInputs = []
        const filteredOutputs = []
        for (let i = 0; i < trainingDataInputsRef.current.length; i++) {
            const item = trainingDataInputsRef.current[i]
            if (Array.isArray(item) && item.length === expectedLength) {
                filteredInputs.push(item)
                filteredOutputs.push(trainingDataOutputsRef.current[i])
            } else {
                console.warn(
                    `Sample ${i} rejected. Expected length ${expectedLength}, got ${Array.isArray(item) ? item.length : typeof item}`
                )
            }
        }

        trainingDataInputsRef.current = filteredInputs
        trainingDataOutputsRef.current = filteredOutputs

        if (trainingDataInputsRef.current.length < 2) {
            throw new Error(
                'Not enough valid samples of consistent length to train.'
            )
        }

        const inputsTensor = tf.tensor2d(trainingDataInputsRef.current)
        const outputsTensor = tf.tensor1d(trainingDataOutputsRef.current, 'int32')
        const oneHotOutputs = tf.oneHot(outputsTensor, classNamesRef.current.length)

        outputsTensor.dispose()

        modelRef.current = buildSequentialModel(expectedLength, classNamesRef.current.length)

        await trainAndSaveModel(inputsTensor, oneHotOutputs)
    }

    const trainAndSaveModel = async (inputsTensor, oneHotOutputs) => {
        setStartTraining(true)

        tf.util.shuffleCombo(trainingDataInputsRef.current, trainingDataOutputsRef.current)

        await modelRef.current.fit(inputsTensor, oneHotOutputs, {
            shuffle: true,
            batchSize: currentModel.batchSize || DEFAULT_BATCH_SIZE,
            epochs: currentModel.epochs || DEFAULT_EPOCHS,
            validationSplit: 0.15,
            callbacks: {
                onEpochEnd: (epoch, logs) => {
                    console.log('Epoch:', epoch, logs)
                },
            },
        })

        // SAVE MODEL TO INDEXEDDB
        await modelRef.current.save(`indexeddb://${currentModel.modelId}`)

        // UPDATE REDUX (mark as trained)
        const updatedModels = props.camModels.map((m) =>
            m.modelId === currentModel.modelId
                ? { ...m, isGenerateTensor: true, audioLabels: classNamesRef.current }
                : m
        )
        await modelsDb.update({
            id: currentModel.modelId,
            modelName: currentModel.modelName,
            audioLabels: classNamesRef.current,
            isGenerateTensor: true,
        })

        props.setModelDetails(updatedModels)
        props.setToggleNextBtn(true)

        setShowModel({
            isShow: true,
            message: 'Model training was successful.',
            type: 'trainSuccessful',
            optionsToSelect: getModelOptions('trainSuccessful'),
        })

        oneHotOutputs.dispose()
        inputsTensor.dispose()
        setStartTraining(false)
    }

    const handelBlurInput = () => {
        if (!modelName.trim()) {
            setShowInputModelName(false)
            setModelName('')
            return
        }
        const err = validateModelName(modelName)
        if (err) {
            setModelNameError(err)
            setTimeout(() => setModelNameError(''), 2000)
            return
        }
        const { message, error } = validateModelNameExists(modelName, -1)
        if (error) {
            setModelNameError(message)
            setTimeout(() => setModelNameError(''), 2000)
            return
        }
        addModel()
        setShowInputModelName(false)
        setModelName('')
    }

    //on modelClick set the current model name
    /**
     * Sets selected model as current model.
     * Also resets Face Detected IF-block slider values
     * in sessionStorage when switching models.
     */
    const handelModelClick = (modelId) => {
        if (props.currentModelId === modelId) return
        props.setCurrentModelId(modelId)

        const allDetails =
            JSON.parse(sessionStorage.getItem('allDetails')) || {}

        for (let key in allDetails) {
            const ele = allDetails[key]

            if (ele.option === 'Face Detected') {
                for (let k in ele) {
                    if (k === 'id') continue
                    if (k === 'sliderValue') {
                        ele[k] = '1'
                    }
                }
            }
        }
        sessionStorage.setItem('allDetails', JSON.stringify(allDetails))
    }

    return (
        <div>
            <DialogModal
                show={showModel.isShow}
                text={showModel.message}
                showCloseBtn={true}
                handleDialogModalClose={() =>
                    setShowModel({ isShow: false, message: '', type: '' })
                }
                optionsToSelect={getModelOptions(showModel.type)}
            />

            {/*--------------------- camera model ----------------------*/}
            <CamModule
                selectedClass={selectedClass}
                isShow={showWebCamModel}
                imageUpload={imageUpload}
                currentModelId={props.currentModelId}
                isPose={currentModel?.detectionType === 'pose'}
                aiCodeMode={aiCodeMode}
                modelType={activeModelType}
                capturePoseSample={capturePoseSample}
                handleDialogModalClose={() =>
                    webCamModelHandel({ value: false, imageUpload: false })
                }
            />

            {/*--------------------- Audio Model ----------------------*/}
            <AudioModule
                className={selectedClass}
                isShow={showAudioModel}
                audioUpload={isAudioUploadOpen}
                classes={classes}
                setClasses={props.setNewClasses}
                currentModelId={props.currentModelId}
                handleDialogModalClose={() =>
                    audioModelHandel({ value: false, audioUpload: false })
                }
            />

            {/*--------------------- NavBar ----------------------*/}
            <div>
                {aiCodeMode ? (
                    props.hideHeader ? null : (
                        <ProgramHeader
                            data={aiCodeHeaderData}
                            // showSave={true}
                            // showHelp={true}
                        />
                    )
                ) : (
                    // <NavBar
                    //     selectbar={selectbarY}
                    //     selectbarwidth="20%"
                    //     headers={[
                    //         { name: 'Enable', color: 'white' },
                    //         { name: 'Control', color: 'black' },
                    //         { name: 'Run', color: 'black' },
                    //     ]}
                    //     showHelp={true}
                    //     // handleHelp={handleClickhelpbtn}
                    // />
                     <ProgramHeader
                            data={{
                                selected: 1,
                                options: [
                                    <p key="Enable">Enable</p>,
                                    <p key="Control">Control</p>,
                                    <p key="Run">Run</p>
                                ],
                            }}
                            // showHelp={true}
                    />
                )}
            </div>

            {/* -------------------- body ------------------------------ */}

            {/* ----------- TRAIN | ROI TOGGLE (only for image training) ----------- */}
            {!isAudioTrain && (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        padding: '10px 30px',
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            background: '#e6e6e6',
                            borderRadius: '25px',
                            padding: '4px',
                            width: '200px',
                        }}
                    >
                        <div
                            onClick={() => setMainTab('train')}
                            style={{
                                flex: 1,
                                textAlign: 'center',
                                padding: '6px 0',
                                borderRadius: '20px',
                                cursor: 'pointer',
                                fontWeight: 500,
                                transition: '0.3s',
                                background:
                                    mainTab === 'train'
                                        ? 'linear-gradient(to right, #f4a756, #f28168)'
                                        : 'transparent',
                                color: mainTab === 'train' ? '#fff' : '#666',
                            }}
                        >
                            Train
                        </div>

                        <div
                            onClick={() => setMainTab('roi')}
                            style={{
                                flex: 1,
                                textAlign: 'center',
                                padding: '6px 0',
                                borderRadius: '20px',
                                cursor: 'pointer',
                                fontWeight: 500,
                                transition: '0.3s',
                                background:
                                    mainTab === 'roi'
                                        ? 'linear-gradient(to right, #f4a756, #f28168)'
                                        : 'transparent',
                                color: mainTab === 'roi' ? '#fff' : '#666',
                            }}
                        >
                            ROI
                        </div>
                    </div>
                </div>
            )}

            {/* Show ROI tab only for image training */}
            {!isAudioTrain && mainTab === 'roi' ? (
                <div
                    style={{
                        display: 'flex',
                        height: aiCodeMode ? 'auto' : '75vh',
                        padding: '20px',
                        gap: '20px',
                        flexWrap: aiCodeMode ? 'wrap' : 'nowrap',
                        alignItems: 'flex-start',
                    }}
                >
                    {/* ---------------- LEFT CAMERA AREA ---------------- */}
                    <div
                        style={{
                            flex: 1,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <ROIModule
                            roiRegions={roiRegions}
                            setRoiRegions={setRoiRegions}
                            activeRegionId={activeRegionId}
                        />
                    </div>

                    {/* ---------------- RIGHT REGION PANEL ---------------- */}
                    <div
                        style={{
                            width: aiCodeMode ? '260px' : '300px',
                            background: '#f5f5f5',
                            borderRadius: '12px',
                            padding: '15px',
                            display: 'flex',
                            flexDirection: 'column',

                            /* MOVE LEFT */
                            marginRight: aiCodeMode ? '0' : '209px',

                            /* MOVE DOWN */
                            marginTop: aiCodeMode ? '0' : '70px',

                            /* ENABLE SCROLL */
                            maxHeight: aiCodeMode ? '60vh' : '65vh',
                            overflowY: 'auto',
                        }}
                    >
                        <button
                            onClick={addRegion}
                            style={{
                                padding: '8px',
                                borderRadius: '8px',
                                border: 'none',
                                background: '#f4a756',
                                color: '#fff',
                                cursor: 'pointer',
                                marginBottom: '15px',
                                fontWeight: 500,
                            }}
                        >
                            + Add Region
                        </button>

                        <div style={{ flex: 1, overflowY: 'auto' }}>
                            {roiRegions.map((region) => (
                                <div
                                    key={region.id}
                                    style={{
                                        background:
                                            activeRegionId === region.id
                                                ? 'linear-gradient(to right,#f4a756,#f28168)'
                                                : '#ffffff',
                                        padding: '10px',
                                        borderRadius: '10px',
                                        marginBottom: '12px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        cursor: 'pointer',
                                    }}
                                    onClick={() => setActiveRegionId(region.id)}
                                >
                                    {/* Editable Name */}
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '6px',
                                            flex: 1,
                                            minWidth: 0,
                                            maxWidth: '140px',
                                            overflow: 'hidden',
                                        }}
                                    >
                                        {editingRegionId === region.id ? (
                                            <input
                                                style={{
                                                    width: '100%',
                                                    border: 'none',
                                                    outline: 'none',
                                                    background: 'transparent',
                                                    fontWeight: 500,
                                                    color:
                                                        activeRegionId ===
                                                        region.id
                                                            ? '#fff'
                                                            : '#333',
                                                }}
                                                autoFocus
                                                value={editingRegionName}
                                                onChange={(e) =>
                                                    setEditingRegionName(
                                                        e.target.value
                                                    )
                                                }
                                                onBlur={() =>
                                                    saveRegionName(region.id)
                                                }
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        saveRegionName(
                                                            region.id
                                                        )
                                                    }
                                                }}
                                                onClick={(e) =>
                                                    e.stopPropagation()
                                                }
                                            />
                                        ) : (
                                            <>
                                                <div
                                                    title={region.name}
                                                    style={{
                                                        fontWeight: 500,
                                                        color:
                                                            activeRegionId ===
                                                            region.id
                                                                ? '#fff'
                                                                : '#333',
                                                        overflow: 'hidden',
                                                        textOverflow:
                                                            'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                        maxWidth: '90px',
                                                    }}
                                                >
                                                    {region.name}
                                                </div>

                                                {/* Pencil Icon */}
                                                <img
                                                    src={renderPrgImage(
                                                        'editPencil'
                                                    )}
                                                    alt="edit"
                                                    width="18px"
                                                    style={{
                                                        cursor: 'pointer',
                                                        opacity:
                                                            activeRegionId ===
                                                            region.id
                                                                ? 1
                                                                : 0.6,
                                                        filter:
                                                            activeRegionId ===
                                                            region.id
                                                                ? 'brightness(0) invert(1)'
                                                                : 'none',
                                                    }}
                                                    onClick={(e) => {
                                                        e.stopPropagation()
                                                        setEditingRegionId(
                                                            region.id
                                                        )
                                                        setEditingRegionName(
                                                            region.name
                                                        )
                                                    }}
                                                />
                                            </>
                                        )}
                                    </div>
                                    {/* Delete Button */}
                                    <div
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            deleteRegion(region.id)
                                        }}
                                        style={{
                                            marginLeft: '10px',
                                            color:
                                                activeRegionId === region.id
                                                    ? '#fff'
                                                    : '#888',
                                            fontWeight: 'bold',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        ✕
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            ) : (
                <div
                    className={styles.train_parent}
                >
                    {/* Left scrollable div */}
                    <div
                        className={styles.train_left}
                        ref={leftContainerRef}
                    >
                        {Object.keys(classes).map((ele) => {
                            const obj = classes?.[ele]
                            return (
                                <div
                                    key={obj.id}
                                    id={`train_left-div-${obj.id}`}
                                    className={styles['train_left-small-div']}
                                >
                                    <LeftTrainingClass
                                        jsPlumbInstanceRef={jsPlumbInstance}
                                        isAudioTrain={isAudioTrain}
                                        obj={obj}
                                        classesObjectKey={ele}
                                        webCamModelOpen={webCamModelHandel}
                                        classes={classes}
                                        audioModelOpen={audioModelHandel}
                                        isShowClassDeleteBtn={isShowClassDeleteBtn}
                                        setAudioUploadOpen={setAudioUploadOpen}
                                        detectionType={
                                            currentModel?.detectionType
                                        }
                                    />
                                </div>
                            )
                        })}

                        <div className={styles['addBtn-div']}>
                            <img
                                src={renderImage('buttonPlusImg')}
                                alt="next"
                                draggable="false"
                                style={{
                                    margin: 0,
                                    width: '3vw',
                                    cursor: 'pointer',
                                }}
                                onClick={addClass}
                            />
                        </div>
                    </div>

                    {/* Connection container for jsPlumb lines */}
                    <div
                        ref={connectionContainerRef}
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            pointerEvents: 'none',
                            zIndex: 100,
                            overflow: 'visible',
                        }}
                    />

                    {/*---------------- Right div -----------------------*/}
                    <div
                        className={styles.train_right}
                    >
                        <div
                            className={styles['train_right-small-div']}
                            id="train_right-small-div"
                        >
                            <p className={styles['ModelHeader']}>
                                Model: {currentModel?.modelName}
                            </p>
                            <div className={styles.toggleContainer}>
                                <div
                                    className={`${styles.toggleBackground} ${
                                        activeTab === 'models' ? styles.right : ''
                                    }`}
                                ></div>

                                <button
                                    className={`${styles.toggleButton} ${
                                        activeTab === 'training'
                                            ? styles.active
                                            : ''
                                    }`}
                                    onClick={() => setActiveTab('training')}
                                >
                                    Training
                                </button>
                                <button
                                    className={`${styles.toggleButton} ${
                                        activeTab === 'models' ? styles.active : ''
                                    }`}
                                    onClick={() => setActiveTab('models')}
                                >
                                    Models
                                </button>
                            </div>

                            {activeTab === 'training' ? (
                                <>
                                    {/* Detection type toggle (only for image training) */}
                                    {!isAudioTrain && (
                                        <div style={{ marginBottom: '16px',width: '80%' }}>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    background: '#e6e6e6',
                                                    borderRadius: '20px',
                                                    padding: '3px',
                                                    width: '100%',
                                                    maxWidth: '340px',
                                                    boxSizing: 'border-box',
                                                    margin: 'auto'
                                                }}
                                            >
                                                {/* What the model recognises. */}
                                               {[
                                                    { value: 'face', label: 'Face' },
                                                    { value: 'object', label: 'Object' },
                                                    { value: 'gesture', label: 'Gesture' },
                                                    { value: 'pose', label: 'Pose' },
                                                ].filter((item) =>
                                                    trainTypeAllowed(item.value)
                                                ).map((opt) => {
                                                    const active =
                                                        activeModelType ===
                                                        opt.value
                                                    return (
                                                        <div
                                                            key={opt.value}
                                                            onClick={() =>
                                                                handleModelTypeChange(
                                                                    opt.value
                                                                )
                                                            }
                                                            style={{
                                                                flex: 1,
                                                                textAlign: 'center',
                                                                padding: '5px 2px',
                                                                borderRadius: '16px',
                                                                fontSize: '11px',
                                                                fontWeight: 500,
                                                                whiteSpace: 'nowrap',
                                                                cursor: 'pointer',
                                                                transition:
                                                                    'all 0.25s ease',
                                                                background: active
                                                                    ? 'linear-gradient(to right, #f4a756, #f28168)'
                                                                    : 'transparent',
                                                                color: active
                                                                    ? '#fff'
                                                                    : '#666',
                                                            }}
                                                        >
                                                            {opt.label}
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                            {/* <p
                                                style={{
                                                    margin: '8px 0 0',
                                                    fontSize: '11px',
                                                    color: '#888',
                                                    maxWidth: '340px',
                                                }}
                                            >
                                                {activeModelType === 'pose'
                                                    ? 'Pose: learns body posture from MoveNet keypoints. Capture full-body shots.'
                                                    : activeModelType === 'gesture'
                                                    ? 'Gesture: learns hand shapes from 21 hand landmarks — works with either hand, any background. Capture clear hand shots.'
                                                    : activeModelType === 'object'
                                                    ? 'Object: learns objects from the whole image. Capture the object filling the frame from several angles.'
                                                    : 'Face: learns faces/scenes from the whole image. Capture the face centered in good light.'}
                                            </p> */}
                                        </div>
                                    )}
                                    <TrainingPanel
                                        currentModel={currentModel}
                                        classes={classes}
                                        startTraining={startTraining}
                                        showEpochsHelp={showEpochsHelp}
                                        showBatchHelp={showBatchHelp}
                                        onEpochsChange={(e) => handelAdvanceChange(e, 'epochs')}
                                        onBatchSizeChange={(e) => handelAdvanceChange(e, 'batchSize')}
                                        onReset={handelReset}
                                        onTrain={handelTrain}
                                        onShowEpochsHelp={() => setShowEpochsHelp(true)}
                                        onHideEpochsHelp={() => setShowEpochsHelp(false)}
                                        onShowBatchHelp={() => setShowBatchHelp(true)}
                                        onHideBatchHelp={() => setShowBatchHelp(false)}
                                    />
                                </>
                            ) : (
                                <div className={styles['modelContainer']} style={{ position: 'relative' }}>
                                    <div className={styles['modelList']} ref={modelListRef}>

                                        {/* ---- Working models (current session) ---- */}
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: '6px 8px 6px' }}>
                                            <span style={{ fontSize: '11px', color: '#aaa', fontFamily: 'Halcyon Regular' }}>
                                                Current Session
                                            </span>
                                            <button
                                                onClick={() => setShowInputModelName(true)}
                                                title="Create a new blank model"
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '4px',
                                                    border: 'none',
                                                    cursor: 'pointer',
                                                    background: 'linear-gradient(to right,rgb(244, 167, 86),rgb(242, 129, 104))',
                                                    color: '#fff',
                                                    borderRadius: '12px',
                                                    padding: '4px 10px',
                                                    fontSize: '11px',
                                                    fontFamily: 'Halcyon Regular',
                                                }}
                                            >
                                                + New model
                                            </button>
                                        </div>
                                        {props.camModels.map((ele) => (
                                            <div key={ele.modelId}>
                                                {editModelId === ele.modelId ? (
                                                    <div className={styles.modelNameInputDiv}>
                                                        <input
                                                            autoFocus
                                                            className={styles.modelNameInput}
                                                            type="text"
                                                            value={editModelName}
                                                            onChange={(e) => setEditModelName(e.target.value)}
                                                            onKeyDown={(e) => { if (e.key === 'Enter') commitRename(); if (e.key === 'Escape') setEditModelId(null) }}
                                                            onBlur={commitRename}
                                                        />
                                                    </div>
                                                ) : (
                                                    <div
                                                        className={styles.eachModelDiv}
                                                        onClick={() => {
                                                            props.setCurrentModelId(ele.modelId)
                                                            setActiveTab('training')
                                                        }}
                                                        style={
                                                            props.currentModelId === ele.modelId
                                                                ? { background: 'linear-gradient(to right,rgb(244, 167, 86),rgb(242, 129, 104))' }
                                                                : {}
                                                        }
                                                    >
                                                        <div className={styles.eachModelName}>{ele.modelName}</div>
                                                        <div className={styles.modelMenuDiv}>
                                                            {/* Rename */}
                                                            <div style={{ position: 'relative' }}>
                                                                <img
                                                                    width={'23px'}
                                                                    style={{ cursor: 'pointer' }}
                                                                    src={renderPrgImage('editPencil')}
                                                                    alt="Rename model"
                                                                    onClick={(e) => { e.stopPropagation(); editBtnClick(ele) }}
                                                                />
                                                                <div className={`${styles.tooltipDiv} ${styles.modelNameEditImgToolTip}`}>Rename model</div>
                                                            </div>
                                                            {/* Save to saved models */}
                                                            <div style={{ position: 'relative' }}>
                                                                <img
                                                                    width={'23px'}
                                                                    style={{ cursor: 'pointer' }}
                                                                    src={renderPrgImage('saveBtn')}
                                                                    alt="Save model"
                                                                    onClick={(e) => saveWorkingModel(ele, e)}
                                                                />
                                                                <div className={`${styles.tooltipDiv} ${styles.modelNameEditImgToolTip}`}>Save model</div>
                                                            </div>
                                                            {/* Copy */}
                                                            <div style={{ position: 'relative' }}>
                                                                <img
                                                                    width={'23px'}
                                                                    style={{ cursor: 'pointer' }}
                                                                    src={renderImage('ActionCopyBtn')}
                                                                    alt="Copy model"
                                                                    onClick={(e) => { e.stopPropagation(); handelCopyModel(ele) }}
                                                                />
                                                                <div className={`${styles.tooltipDiv} ${styles.modelNameEditImgToolTip}`}>Copy model</div>
                                                            </div>
                                                            {/* Delete */}
                                                            <div style={{ position: 'relative' }}>
                                                                <img
                                                                    width={'23px'}
                                                                    style={{ cursor: props.camModels.length > 1 ? 'pointer' : 'default', opacity: props.camModels.length > 1 ? 1 : 0.3 }}
                                                                    src={renderPrgImage('deleteEnable')}
                                                                    alt="Delete model"
                                                                    onClick={(e) => { e.stopPropagation(); deleteWorkingModel(ele.modelId) }}
                                                                />
                                                                <div className={`${styles.tooltipDiv} ${styles.deleteModelImgToolTip}`}>Delete model</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        ))}

                                        <ModelNameDialog
                                            isOpen={showInputModelName}
                                            modelName={modelName}
                                            modelNameError={modelNameError}
                                            onChange={handelChangeModelName}
                                            onSave={handelBlurInput}
                                            onClose={() => { setShowInputModelName(false); setModelName('') }}
                                        />

                                        <p style={{ margin: '10px 8px 2px', fontSize: '11px', color: '#aaa', fontFamily: 'Halcyon Regular' }}>
                                            Saved Models
                                        </p>
                                        {savedModelsLoading ? (
                                            <p style={{ textAlign: 'center', padding: '8px', fontFamily: 'Halcyon Regular', fontSize: '12px' }}>
                                                Loading...
                                            </p>
                                        ) : savedModels.length === 0 ? (
                                            <p style={{ padding: '4px 8px', fontFamily: 'Halcyon Regular', fontSize: '12px', color: '#bbb' }}>
                                                No saved models yet.
                                            </p>
                                        ) : (
                                            savedModels.map((savedModel) => (
                                                <div
                                                    key={savedModel.id}
                                                    className={styles.eachModelDiv}
                                                    onClick={() => loadSavedModel(savedModel)}
                                                    title="Load into the current session to train again"
                                                    style={{ background: 'linear-gradient(to right,#f0f0f0,#e8e8e8)' }}
                                                >
                                                    <div className={styles.eachModelName}>{savedModel.modelName}</div>
                                                    <div className={styles.modelMenuDiv}>
                                                        <div style={{ position: 'relative' }}>
                                                            <img
                                                                width={'23px'}
                                                                style={{ cursor: 'pointer' }}
                                                                src={renderPrgImage('deleteEnable')}
                                                                alt="Delete saved model"
                                                                onClick={(e) => deleteSavedModel(savedModel.id, e)}
                                                            />
                                                            <div className={`${styles.tooltipDiv} ${styles.deleteModelImgToolTip}`}>Delete model</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        )}
                                    </div>

                                    {modelNameError && (
                                        <p className={styles.modelNameInputError}>{modelNameError}</p>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/*--------------- Footer -------------------------*/}
            {/* When embedded (AI-code Configure) the host page supplies its own
                Back/Next arrows, so the TrainMachine footer is hidden. */}
            {!props.hideHeader && (
                <div>
                    <img
                        src={nextY}
                        alt="next"
                        draggable="false"
                        style={{
                            margin: 0,
                            position: 'absolute',
                            top: '92vh',
                            left: '95.8vw',
                            width: '3vw',
                            cursor: isEnableNextBtn ? 'pointer' : 'default',
                            transform: 'translate(-50%, -50%)',
                            opacity: isEnableNextBtn ? '1' : '0.5',
                        }}
                        onClick={() => nextButtonHandel()}
                    />

                    <img
                        src={backY}
                        alt="back"
                        draggable="false"
                        style={{
                            margin: 0,
                            position: 'absolute',
                            top: '92vh',
                            right: '92.7vw',
                            width: '3vw',
                            cursor: 'pointer',
                            transform: 'translate(-50%, -50%)',
                        }}
                        onClick={() =>
                            history.push(aiCodeMode ? '/ai-code' : '/chooseDevice')
                        }
                    />
                </div>
            )}
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        appModeStorage: state.appModeStorage,
        AudioClasses: state.appModeStorage.trainMachine.AudioClasses,
        advanceSetting: state.appModeStorage.trainMachine.advanceSetting,
        camModels: state.appModeStorage.trainMachine.camModels,
        currentModelId: state.appModeStorage.trainMachine.currentModelId,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setNewClasses: (data) => {
            dispatch({ type: 'ADD_CLASSES', payload: data })
        },
        setAdvanceSetting: (data) => {
            dispatch({ type: 'ADVANCE_SETTING', payload: data })
        },

        setToggleNextBtn: (data) => {
            dispatch({ type: 'TOGGLE_NEXT_BTN', payload: data })
        },
        setModelDetails: (data) => {
            dispatch({ type: 'SET_MODEL_DETAILS', payload: data })
        },
        setCurrentModelId: (data) => {
            dispatch({ type: 'SET_CURRENT_MODEL_ID', payload: data })
        },
        savePoseSample: (classKey, poseVector) => {
            dispatch({
                type: 'ADD_POSE_SAMPLE',
                payload: { classKey, poseVector },
            })
        },
        deletePoseSample: (classKey, index) => {
            dispatch({
                type: 'DELETE_POSE_SAMPLE',
                payload: { classKey, index },
            })
        },
        deletePoseClass: (classKey) => {
            dispatch({
                type: 'DELETE_POSE_CLASS',
                payload: { classKey },
            })
        },

        clearAllPoseSamples: (classKey) => {
            dispatch({
                type: 'CLEAR_ALL_POSE_SAMPLES',
                payload: { classKey },
            })
        },

        renamePoseClass: (payload) => {
            dispatch({
                type: 'CHANGE_CLASSES',
                payload,
            })
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TrainMachine)
